/* zweiherzig — Warenkorb-Erweiterungen
   Versandfortschritt, Ergaenzungsvorschlaege, Vertrauenszeile.
   Zweisprachig: die Sprache kommt aus <html lang>, gesetzt von Shopify.

   Vorschaubilder: KEIN loading="lazy" — in einer beim Seitenaufbau unsichtbaren
   Schublade laedt der Browser verzoegerte Bilder nie nach. */
(function () {
  "use strict";

  var THRESHOLD = 14900;
  var SOURCE = "/collections/sale/products.json?limit=250";
  var MAX_SUGGESTIONS = 2;

  var EN = (document.documentElement.lang || "de").toLowerCase().indexOf("en") === 0;

  var T = EN ? {
    shipFree: "Shipping is free.",
    shipGapA: "Only ", shipGapB: " to go for free shipping",
    freeFrom: "Free from ",
    addTitleFree: "Goes well with this",
    addTitleGap: "This makes shipping free",
    addWhyFree: "From the same range.",
    addWhyGapA: "Less than shipping \u2014 and it stays with you.",
    addBtn: "Add",
    errMsg: "Could not be added.", errFix: "Please try again.", errBtn: "Retry",
    trust1: "Ships in 1\u20133 days", trust2: "30-day returns"
  } : {
    shipFree: "Versand ist frei.",
    shipGapA: "Noch ", shipGapB: " bis zum Gratisversand",
    freeFrom: "Gratis ab ",
    addTitleFree: "Passt dazu",
    addTitleGap: "Damit ist der Versand frei",
    addWhyFree: "Aus derselben Serie.",
    addWhyGapA: "Kostet weniger als der Versand \u2014 und bleibt bei dir.",
    addBtn: "Hinzuf\u00fcgen",
    errMsg: "Konnte nicht hinzugef\u00fcgt werden.", errFix: "Bitte noch einmal versuchen.", errBtn: "Nochmal",
    trust1: "Versandfertig in 1\u20133 Tagen", trust2: "30 Tage R\u00fcckgabe"
  };

  var catalogue = null, busy = false, lastError = null;

  function eur(c){
    var n = (c/100).toFixed(2);
    return EN ? "\u20ac\u00a0" + n : n.replace(".", ",") + "\u00a0\u20ac";
  }
  function el(h){ var d=document.createElement("div"); d.innerHTML=h.trim(); return d.firstElementChild }
  function thumb(u, px){ return u ? u + (u.indexOf("?")===-1?"?":"&") + "width=" + px : "" }

  function getCart(){ return fetch("/cart.js",{headers:{Accept:"application/json"}}).then(function(r){return r.json()}) }

  function getCatalogue(){
    if (catalogue) return Promise.resolve(catalogue);
    return fetch(SOURCE,{headers:{Accept:"application/json"}})
      .then(function(r){ return r.json() })
      .then(function(d){
        catalogue = (d.products||[]).map(function(p){
          var v = (p.variants||[]).filter(function(x){ return x.available })[0];
          if (!v) return null;
          return { id:v.id, title:p.title,
            price: Math.round(parseFloat(v.price)*100),
            compare: v.compare_at_price ? Math.round(parseFloat(v.compare_at_price)*100) : null,
            img: (p.images && p.images[0] && p.images[0].src) || "" };
        }).filter(Boolean);
        return catalogue;
      })
      .catch(function(){ catalogue = []; return catalogue });
  }

  function shipMarkup(cart){
    var gap = Math.max(0, THRESHOLD - cart.total_price);
    var free = gap === 0;
    var pct = Math.min(100, (cart.total_price / THRESHOLD) * 100);
    return '<div class="zwh-ship' + (free ? " zwh-ship--free" : "") + '">' +
      '<div class="zwh-ship__head">' +
        '<span class="zwh-ship__msg" role="status">' +
          (free ? T.shipFree : T.shipGapA + '<span class="zwh-ship__gap">' + eur(gap) + "</span>" + T.shipGapB) +
        '</span><span class="zwh-ship__of">' + T.freeFrom + eur(THRESHOLD) + "</span></div>" +
      '<div class="zwh-ship__track"><div class="zwh-ship__fill" style="width:' + pct + '%"></div></div></div>';
  }

  function pick(cart, list){
    var inCart = (cart.items||[]).map(function(i){ return i.variant_id });
    var gap = Math.max(0, THRESHOLD - cart.total_price);
    var pool = list.filter(function(p){ return inCart.indexOf(p.id) === -1 });
    var fitting = gap === 0 ? pool : pool.filter(function(p){ return p.price >= gap });
    fitting.sort(function(a,b){ return a.price - b.price });
    var chosen = fitting.slice(0, MAX_SUGGESTIONS);
    if (!chosen.length) chosen = pool.sort(function(a,b){ return a.price-b.price }).slice(0, MAX_SUGGESTIONS);
    return chosen;
  }

  function addMarkup(cart, items){
    if (!items.length) return "";
    var free = cart.total_price >= THRESHOLD;
    var rows = items.map(function(p){
      var price = "<span>" + eur(p.price) + "</span>";
      if (p.compare && p.compare > p.price) price = "<s>" + eur(p.compare) + "</s>" + price;
      var src = thumb(p.img, 120);
      return '<div class="zwh-add__row">' +
        (src ? '<img src="' + src + '" alt="" width="44" height="44" decoding="async">' : "") +
        '<div class="zwh-add__t"><div class="zwh-add__n">' + p.title + "</div>" +
        '<div class="zwh-add__p">' + price + "</div></div>" +
        '<button type="button" class="zwh-add__btn" data-zwh-add="' + p.id + '">' + T.addBtn + "</button></div>";
    }).join("");

    var err = lastError
      ? '<div class="zwh-err"><div>' + T.errMsg + "<strong>" + T.errFix + "</strong></div>" +
        '<button type="button" class="zwh-add__btn" data-zwh-add="' + lastError.id + '">' + T.errBtn + "</button></div>"
      : "";

    return '<div class="zwh-add">' +
      '<h3 class="zwh-add__title">' + (free ? T.addTitleFree : T.addTitleGap) + "</h3>" +
      '<p class="zwh-add__why">' + (free ? T.addWhyFree : T.addWhyGapA) + "</p>" + err + rows +
      '<div class="zwh-trust"><span>' + T.trust1 + "</span><span>" + T.trust2 + "</span></div></div>";
  }

  function hosts(){
    var out = [];
    var drawer = document.querySelector("cart-drawer .drawer__inner");
    if (drawer) out.push({ root:drawer, top:drawer.querySelector(".drawer__header"), bottom:drawer.querySelector(".drawer__footer") });
    var page = document.querySelector(".cart__items");
    if (page) out.push({ root:page.parentElement, top:null, bottom:null });
    return out;
  }

  function paint(cart, items){
    hosts().forEach(function(h){
      var old; while ((old = h.root.querySelector(".zwh-ship, .zwh-add"))) old.remove();
      var ship = el(shipMarkup(cart));
      if (h.top && h.top.nextSibling) h.root.insertBefore(ship, h.top.nextSibling);
      else h.root.insertBefore(ship, h.root.firstChild);
      var add = addMarkup(cart, items);
      if (add){
        var node = el(add);
        if (h.bottom) h.root.insertBefore(node, h.bottom);
        else h.root.appendChild(node);
      }
    });
  }

  function refresh(){
    if (busy) return;
    return Promise.all([getCart(), getCatalogue()]).then(function(r){
      var cart = r[0];
      if (!cart || !cart.items || !cart.items.length){
        hosts().forEach(function(h){ var o; while ((o = h.root.querySelector(".zwh-ship, .zwh-add"))) o.remove() });
        return;
      }
      paint(cart, pick(cart, r[1]));
    });
  }

  function addToCart(id, btn){
    if (busy) return;
    busy = true; lastError = null;
    if (btn){ btn.setAttribute("aria-busy","true"); btn.textContent = "\u2026" }
    fetch("/cart/add.js", {
      method:"POST",
      headers:{ "Content-Type":"application/json", Accept:"application/json" },
      body: JSON.stringify({ items:[{ id:Number(id), quantity:1 }] })
    })
      .then(function(r){ if(!r.ok) throw new Error("add failed"); return r.json() })
      .then(function(){ return rerenderDawn() })
      .catch(function(){ lastError = { id:id } })
      .then(function(){ busy = false; return refresh() });
  }

  function rerenderDawn(){
    return fetch("/?sections=cart-drawer,cart-icon-bubble", { headers:{Accept:"application/json"} })
      .then(function(r){ return r.json() })
      .then(function(s){
        if (s["cart-drawer"]){
          var fresh = new DOMParser().parseFromString(s["cart-drawer"], "text/html");
          var ni = fresh.querySelector(".drawer__inner");
          var cur = document.querySelector("cart-drawer");
          var ci = cur && cur.querySelector(".drawer__inner");
          if (ni && ci) ci.innerHTML = ni.innerHTML;
          if (cur) cur.classList.remove("is-empty");
        }
        if (s["cart-icon-bubble"]){
          var b = document.getElementById("cart-icon-bubble");
          var nb = new DOMParser().parseFromString(s["cart-icon-bubble"], "text/html").getElementById("cart-icon-bubble");
          if (b && nb) b.innerHTML = nb.innerHTML;
        }
      })
      .catch(function(){});
  }

  document.addEventListener("click", function(e){
    var b = e.target.closest("[data-zwh-add]");
    if (!b) return;
    e.preventDefault();
    addToCart(b.getAttribute("data-zwh-add"), b);
  });

  var timer = null;
  function schedule(){ clearTimeout(timer); timer = setTimeout(refresh, 120) }

  function watch(){
    var drawer = document.querySelector("cart-drawer");
    if (drawer){
      new MutationObserver(function(muts){
        for (var i=0;i<muts.length;i++){
          var t = muts[i].target;
          if (t.closest && t.closest(".zwh-ship, .zwh-add")) return;
        }
        schedule();
      }).observe(drawer, { childList:true, subtree:true });
    }
    document.addEventListener("cart:refresh", schedule);
    document.addEventListener("cart:updated", schedule);
    schedule();
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", watch);
  else watch();
})();
